/**
 * @flow
 * @relayHash 12e3cdecd34e932de14be4aff4ffaf10
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddEditVendorModal_vendor$ref = any;
export type VendorListQueryVariables = {||};
export type VendorListQueryResponse = {|
  +vendors: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +vendorNumber: string,
        +name: string,
        +email: ?string,
        +phone: ?string,
        +address: ?string,
        +city: ?string,
        +state: ?string,
        +zipCode: ?string,
        +country: ?string,
        +paymentTerms: ?string,
        +rating: ?number,
        +createdAt: any,
        +updatedAt: any,
        +$fragmentRefs: AddEditVendorModal_vendor$ref,
      |}
    |}>
  |}
|};
export type VendorListQuery = {|
  variables: VendorListQueryVariables,
  response: VendorListQueryResponse,
|};
*/


/*
query VendorListQuery {
  vendors(first: 1000) {
    edges {
      node {
        id
        vendorNumber
        name
        email
        phone
        address
        city
        state
        zipCode
        country
        paymentTerms
        rating
        createdAt
        updatedAt
        ...AddEditVendorModal_vendor
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddEditVendorModal_vendor on Vendor {
  id
  vendorNumber
  name
  email
  phone
  address
  city
  state
  zipCode
  country
  paymentTerms
  rating
  itemPrices {
    edges {
      node {
        id
        item {
          id
          name
        }
        unitPrice
        leadTimeDays
        isPreferred
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendorNumber",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "city",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "paymentTerms",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VendorListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "vendors",
        "name": "__VendorList_vendors_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "VendorConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "AddEditVendorModal_vendor",
                    "args": null
                  }
                ]
              },
              (v15/*: any*/)
            ]
          },
          (v16/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "VendorListQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendors",
        "storageKey": "vendors(first:1000)",
        "args": (v17/*: any*/),
        "concreteType": "VendorConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Vendor",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "itemPrices",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorItemPriceConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VendorItemPriceEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VendorItemPrice",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                  (v0/*: any*/),
                                  (v2/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "unitPrice",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "leadTimeDays",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isPreferred",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              },
              (v15/*: any*/)
            ]
          },
          (v16/*: any*/)
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "vendors",
        "args": (v17/*: any*/),
        "handle": "connection",
        "key": "VendorList_vendors",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "VendorListQuery",
    "id": null,
    "text": "query VendorListQuery {\n  vendors(first: 1000) {\n    edges {\n      node {\n        id\n        vendorNumber\n        name\n        email\n        phone\n        address\n        city\n        state\n        zipCode\n        country\n        paymentTerms\n        rating\n        createdAt\n        updatedAt\n        ...AddEditVendorModal_vendor\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddEditVendorModal_vendor on Vendor {\n  id\n  vendorNumber\n  name\n  email\n  phone\n  address\n  city\n  state\n  zipCode\n  country\n  paymentTerms\n  rating\n  itemPrices {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        unitPrice\n        leadTimeDays\n        isPreferred\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "vendors"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '52570966cca1166d2822217902a4cdb8';
module.exports = node;
